export default {
    i18n: {
        "Device Name": "Cihaz İsmi",
        "day": "Gün",
        "Device Information": "Cihaz Bilgisi",
        "Http": "HTTP",
        "handset": "Ahize",
        "Card": "Kart",
        "Fingerprint": "Parmak izi",
        "Date Time": "Tarih Saat",
        "name": "isim",
        "Volume": "Ses",
        "timezone": "zaman dilimi",
        "Are you sure you want to delete this device?": "Bu cihazı silmek istediğinizden emin misiniz?",
        "Attendance Point Name": "Katılım Noktası Adı",
        "Mac": "MAC",
        "confirmToDeleteIt?": "Silmek istediğinizden emin misiniz?",
        "captureLogs": "Ekran Görüntüsü Kayıtları",
        "Doors": "Kapılar",
        "All Doors": "Tüm Kapılar",
        "Lock List": "Kilit Listesi",
        "Link Device Relay": "Cihaz Rölesini Bağla",
        "Added Successfully!": "Başarıyla Eklendi!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Kilit bir röle ile bağlandığında, röle tetiklendiğinde kilit açılacaktır.",
        "Adding...": "Ekleniyor…",
        "Please try again 24 hours later.": "Lütfen 24 saat sonra tekrar deneyiniz.",
        "Action": "Eylem",
        "unlock": "Kapı Aç",
        "Address": "Adres",
        "Owner": "Ev Sahibi",
        "Failed": "Arızalı",
        "Timeout": "Zaman Aşımı",
        "Response": "Cevap",
        "caller": "Arayan",
        "receiver": "Alıcı",
        "doorLogs": "Kapı Geçiş Kayıtları",
        "callHistory": "Arama Geçmişi",
        "UID": "Kullanıcı ID",
        "Call Type": "Çağrı Türü",
        "Code": "Kod",
        "User": "Kullanıcı",
        "Device List": "Cihaz Listesi",
        "Model": "Model",
        "Time": "Zaman",
        "Company": "Şirket",
        "Property Managers": "Site Yöneticileri",
        "Current Version": "Şimdiki versiyonu",
        "indoorMonitor": "İç Ünite",
        "guardPhone": "Güvenlik Konsolu",
        "close": "Kapalı",
        "Success": "Başarılı",
        "URL": "Url",
        "Please select a device.": "Lütfen bir cihaz seçiniz.",
        "Password is too weak.": "Şifre çok zayıf.",
        "Company is required.": "Şirket bilgisi gerekli.",
        "Your account is not activated, please contact your service provider.": "Hesabınız aktif değil,Lütfen servis sağlayıcınızla iletişime geçiniz.",
        "Language": "Dil",
        "Face": "Yüz",
        "Please set at least one access type.": "Lütfen en az bir erişim türü belirleyin.",
        "Please contact your service provider to activate this advanced feature.": "Bu gelişmiş özelliği etkinleştirmek için lütfen servis sağlayıcınıza başvurun.",
        "Community name": "Topluluk ismi",
        "Please enable PM App first.": "Lütfen önce Site Yöneticisi Uygulamasını etkinleştirin.",
        "Username": "Kullanıcı Adı",
        "Change Log": "Değişiklik Günlüğü",
        "Assign": "Atamak",
        "Floor": "Kat",
        "Link Device": "Cihazı Bağla",
        "Accessible Floors": "Erişilebilir Katlar",
        "Upgrade": "Güncelleme",
        "Function": "İşlev",
        "callDuration": "Çağrı Süresi",
        "No": "Hayır",
        "Verification Code": "Doğrulama Kodu",
        "Expiration Time": "Geçerlilik Süresi",
        "PIN": "Şifre",
        "MAC": "MAC",
        "Building": "Bina",
        "APT": "Daire",
        "ID": "ID",
        "Name": "İsim",
        "activities": "Faaliyetler",
        "Obtain": "Okut",
        "call": "Arama",
        "Group Call": "Grup Araması",
        "Delete": "Sil",
        "Yes": "Evet",
        "Door Release PIN": "Kapı Açma PIN\'i",
        "Email": "E-posta",
        "Mobile Number doesn\'t exist.": "Cep Numarası mevcut değil.",
        "Tips": "Tipler",
        "Password": "Şifre",
        "The end time cannot be earlier than the start time.": "Bitiş zamanı başlangıç zamanından daha önce olamaz.",
        "Back": "Geri",
        "File format error.": "Dosya biçimi hatası.",
        "motionDetection": "Hareket Algılama",
        "You are trying too often, please try again in 5 minutes": "Çok fazla denediniz, lütfen 5 dakika sonra tekrar deneyin",
        "User name too long.": "Kullanıcı adı çok uzun.",
        "This MAC address is redirected on RPS.": "Bu MAC adresi RPS\'ye yönlendirilir.",
        "No Answer": "Cevap Yok",
        "failedToUnlock": "Kapı Açma Başarısız",
        "visitor": "ziyaretçi",
        "yesterday": "Dün",
        "Too large data! Please first export the data before %s first,thanks.": "Çok büyük veri! Lütfen önce verileri %s den önce dışa aktarın, teşekkürler.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Lütfen ödenmemiş sipariş olup olmadığını kontrol edin, yoksa lütfen servis sağlayıcınıza başvurun.",
        "lock": "Kapıyı Kapat",
        "open": "Açık",
        "The PersonalAccount is not active.": "Kişisel Hesap aktif değil.",
        "You cannot link an account that already link other accounts.": "Zaten başka hesapları bağlayan bir hesabı bağlayamazsınız.",
        "You cannot link multiple property manager accounts under the same installer account.": "Aynı yükleyici hesabı altında birden fazla site yöneticisi hesabı bağlayamazsınız.",
        "You cannot link to the currently logged in account.": "Şu anda oturum açmış olduğunuz hesaba bağlantı veremezsiniz.",
        "nfc": "NFC",
        "Delete Device": "Cihazı Sil",
        "date": "Tarih",
        "Device deleted successfully": "Cihaz başarıyla silindi",
        "Failed to delete device": "Cihaz silinemedi",
        "Are you sure you want to cancel?": "İptal etmek istediğinizden emin misiniz?",
        "Unlimited": "Sınırsız",
        "Password Incorrect.": "Yanlış şifre.",
        "deliverySystemVerification": "Teslimat Sistemi Doğrulaması",
        "auto": "Otomatik",
        "Group": "Grup",
        "None": "Hiçbiri",
        "Upgrading...": "Güncelleniyor...",
        "amenityReservation": "İşletme Rezervasyon",
        "idAccess": "Kimlik Erişim",
        "exitButton": "Kapı Açma Düğmesi",
        "Please select at least one item.": "Lütfen en az bir ürün seçiniz.",
        "The ID can contain only digits and letters, up to 32 characters.": "Kimlik 32 karaktere kadar sadece rakam ve harf içerebilir.",
        "The PIN is not available.": "PIN kodu mevcut değil.",
        "minutes": "dakika",
        "Change WiFi": "WiFi\'yi değiştir",
        "Access Denied.": "Kapı Açılmadı.",
        "RF Card": "RF Kart",
        "Phone number": "Telefon numarası",
        "Invalid {0}.": "Geçersiz {0}.",
        "{0} already exists.": "{0} zaten mevcut.",
        "Operation failed!": "İşlem başarısız!",
        "Failed to get data.": "Veri alınamadı.",
        "You do not have the necessary permissions to perform this operation.": "Bu işlemi gerçekleştirmek için gerekli izinlere sahip değilsiniz.",
        "You can only import one template at a time in the current site.": "Mevcut siteye aynı anda yalnızca bir şablon aktarabilirsiniz.",
        "Delivery name": "Kurye yetkilendirme adı",
        "MAC address not in the MAC library.": "MAC adresi MAC kütüphanesinde değil.",
        "Please delete devices under this building.": "Lütfen bu binanın altındaki cihazları silin.",
        "The start time cannot be later than the end time.": "Başlangıç ​​saati bitiş saatinden sonra olamaz.",
        "emergency action type": "acil eylem türü",
        "Only 1000 data items can be imported at a time.": "Aynı anda en fazla 1000 veri öğesi içe aktarılabilir.",
        "The password is too short.": "Şifre çok kısa.",
        "The data has been updated. Please refresh the page and try again.": "Veriler güncellenmiştir. Lütfen sayfayı yenileyin ve tekrar deneyin.",
        "AutoP length must be less 2048 bytes.": "AutoP uzunluğu 2048 bayttan az olmalıdır.",
        "File Check Failed": "Dosya Kontrolü Başarısız",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Yönetici hesabı girişi süresi doldu. Lütfen servis sağlayıcınızla iletişime geçin.",
        "iqPinVerificationFailed": "IQ PIN doğrulaması başarısız oldu.",
        "accountBlacklisted": "Hesap kara listeye alındı.",
        "outsideAuthorizedTime": "Yetkili saatlerin dışında.",
        "network group": "Ağ Grubu",
        "Company name": "Firma adı",
        "Group name": "Grup adı",
        "relay": "röle",
        "motionTime": "hareket Zamanı",
        "motionType": "hareket Tipi",
        "postalCode": "Posta Kodu",
        "floor format": "kat formatı",
        "mobilePhone": "cep telefonu numarası",
        "time format": "zaman formatı",
        "security relay": "güvenlik rölesi",
        "Param": "Parametre",
        "Offline Code": "Çevrimdışı Kod",
        "Add akubela Smart Locks": "Akubela Akıllı Kilit Ekle",
        "Module Version": "Modül Versiyonu",
        "Lock Body Version": "Kilit Gövde Sürümü",
        "Available Version": "Mevcut Sürüm",
        "Please wake up the lock screen and then upgrade.": "Lütfen kilit ekranını uyandırın ve ardından güncellemeyi yapın.",
        "This process will take some time, please be patient.": "İşlem biraz zaman alabilir, lütfen sabırlı olun ",
        "Please confirm that the WiFi network is functioning properly.": "Lütfen WiFi ağının düzgün çalıştığını doğrulayın.",
        "Please wake up the lock screen.": "Lütfen kilit ekranını uyandırın.",
        "This lock has already been added to another apartment.": "Bu kilit daha önce başka bir daireye eklenmiş.",
        "This lock has already been added to the apartment.": "Bu kilit daireye daha önceden eklenmiş.",
        "Pin Code": "Pin Kod",
        "Too many failed attempts, please try again in a few minutes.": "Çok fazla başarısız girişim oldu, lütfen birkaç dakika sonra tekrar deneyin.",
        "Login Account": "Giriş Hesabı",
        "Same account cannot login in different ins.": "Aynı hesap farklı kurulumcularda oturum açamaz.",
        "Lock Name": "Kilit Adı",
        "Smart Locks": "Akıllı Kilitler",
        "Add Smart Lock": "Akıllı Kilit Ekle",
        "The selected duration cannot be more than one year.": "Seçilen süre bir yıldan fazla olamaz.",
        "The end time of the break time cannot be later than the end work time.": "Mola süresinin bitiş saati mesai bitiş saatinden sonra olamaz.",
        "The start time of the break time cannot be earlier than the start work time.": "Mola süresinin başlangıç ​​saati, mesainin başlangıç ​​saatinden önce olamaz.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Geçerli kayıt saatinin bitiş saati mesai bitiş saatinden daha erken olamaz.",
        "The start time of the valid check time cannot be later than the start work time.": "Geçerli kontrol saatinin başlangıç ​​saati, çalışma başlangıç ​​saatinden sonra olamaz.",
        "Deleting failed. The timetable is used by a shift.": "Silme başarısız. Zaman çizelgesi bir vardiya tarafından kullanılıyor.",
        "Deleting failed. The shift is in use.": "Silme başarısız. Vardiya kullanımda.",
        "Deleting failed. The leave type is in use.": "Silme başarısız. İzin türü kullanımda.",
        "Valid time conflicts with an existing schedule.": "Geçerli zaman mevcut bir programla çakışıyor.",
        "The timing for multiple schedules must not coincide.": "Birden fazla programın zamanlaması çakışmamalıdır.",
        "Attendance Log": "Yoklama Kaydı",
        "Added Failed!": "Ekleme Başarısız!",
        "Setting WiFi": "WiFi Ayarı",
        "License Plate": "Plaka",
        "key": "Şifre",
        "IQ Offline.": "IQ Çevrimdışı.",
        "{0}Unlock": "{0} Kilidini aç",
        "automatically": "Otomatik Olarak",
        "manually": "Manuel Olarak",
        "Video Storage": "Video Depolama",
        "Device(s) for Video Storage": "Cihaz(lar) için Video Depolama",
        "The amount of exported data is too large. Please export it in batches.": "Dışa aktarılan veri miktarı çok büyük. Lütfen bunları gruplar halinde dışa aktarın.",
        "Auto-record video when door unlocks": "Kapı açıldığında otomatik video kaydı",
        "Auto-record video during calls": "Arama sırasında otomatik video kaydı",
        "Manual video recording in monitoring": "İzlemede manuel video kaydı",
        "Saved for 30days/60days/90days": "30 gün/60 gün/90 gün boyunca kaydedildi",
        "To subscribe, please contact your provider for activation.": "Abone olmak için lütfen aktivasyon için sağlayıcınızla iletişime geçin.",
        "Saved for {0}days": "{0} gün boyunca kaydedildi",
        "Subscribed Plan": "Abonelik Planı",
        "Supported Devices: {0}": "Desteklenen Aygıtlar: {0}",
        "{0}Lock": "{0} Kilit",
        "Video Saving": "Video Kaydetme",
        "Download Completed!": "İndirme Tamamlandı!",
        "Fail to download.": "İndirme Başarısız.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Silme başarısız! Site yöneticisi bir RentManager Müşterisine bağlandı, öncelikle onu silmelisiniz.",
        "No log to be exported.": "Dışarı aktarılan kayıt yok.",
        "capture&Video": "Yakalama ve Video",
        "packageDetection": "Paket Algılama",
        "Time format is invalid.": "Saat biçimi geçersiz.",
        "No permission to export logs of this type.": "Bu tür günlükleri dışa aktarma izni yok.",
        "Project type is invalid.": "Proje türü geçersiz.",
        "Salto Account Blocked.": "Salto Hesabı Kilitlendi",
        "Remote open not in access group.": "Uzaktan açma erişim grubunda değil.",
        "SIP Account required.": "SIP Hesabı gerekli.",
        "The PIN must be {0} digits.": "PIN kodunuz {0} haneli olmalıdır.",
        "gatewayConnectionUnavailable": "Ağ Geçidi Bağlantısı Kullanılamıyor.",
        "Invalid Username or Password": "Geçersiz Kullanıcı adı ve Şifre",
        "Account already linked to another user.": "Hesap zaten başka bir kullanıcıya bağlı.",
        "The account has been added by another user.": "Hesap başka bir kullanıcı tarafından eklendi.",
        "Failed to add. This user already has 5 license plates.": "Ekleme başarısız. Bu kullanıcının zaten 5 plakası var.",
        "Please at least select a door.": "Lütfen en az bir kapı seçin.",
        "UHF Card": "UHF Kart",
        "personnel": "personel",
        "Parking Lot Name": "Otopark Adı",
        "Controlled Relay": "Kontrollü Röle",
        "No Permission": "İzin Yok",
        "Please ensure that all doors in the project are activated at the same time.": "Lütfen projedeki tüm kapıların aynı anda aktif olduğundan emin olun.",
        "gatewayBusy": "Geçit meşgul",
        "Please set the perimeter door group first.": "Lütfen öncelikle çevre kapısı grubunu ayarlayın.",
        "Please ensure that all doors in the project are renewed at the same time.": "Lütfen projedeki tüm kapıların aynı anda yenilenmesini sağlayın.",
        "When lockdown is on, the controlled relay cannot be modified.": "Kilitleme açıkken, kontrollü röle değiştirilemez.",
        "DetectionLogs": "Algılama Kayıtları",
        "packageIn": "Paket İçinde",
        "packageOut": "Paket Dışarı",
        "View Progress": "İlerlemeyi Görüntüle",
        "Check if the WiFi is operating on the 2.4GHz band.": "WiFi\'ın 2,4 GHz bandında çalışıp çalışmadığını kontrol edin.",
        "Verify that the WiFi password is correct.": "WiFi şifrenizin doğru olduğundan emin olun.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Hotspot yapılandırması sırasında doğru cihaz hotspot\'una bağlı olduğunuzdan emin olun.",
        "Offline Code Unlock": "Çevrimdışı Kod Kilidi Açma",
        "Salto Token Expired.": "Salto Jetonu Süresi Doldu.",
        "Lock Offline": "Kilit Çevrimdışı",
        "identity information! Please login again": "Kimlik bilgileri! Lütfen tekrar giriş yapın",
        "Email is required.": "E-posta gereklidir.",
        "Mobile number is required.": "Mobil numarası gereklidir.",
        "You can\'t make payments for offices in different time zones.": "Farklı saat dilimlerindeki ofisler için ödeme yapamazsınız.",
        "The current scheduling staff exceeds 200 people.": "Mevcut vardiya personeli 200 kişiyi aşıyor.",
        "param": "parametre",
        "Invalid UserName or Password": "Geçersiz Kullanıcı Adı veya Şifre",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Salto KS hesabınızın kilidin adını değiştirme izni yok.",
        "Owner is required.": "Sahip gerekli.",
        "Office is required.": "Ofis gereklidir.",
        "PIN or RF Card is required.": "PIN veya RF Kart gereklidir.",
        "RF card": "RF kartı",
        "Personnel is required.": "Personel gereklidir.",
        "email address": "e-posta adresi",
        "mobile number": "cep telefonu numarası",
        "The length must be less than 32 characters.": "Uzunluk 32 karakterden az olmalıdır.",
        "The length must be less than 256 characters.": "Uzunluk 256 karakterden az olmalıdır.",
        "Access Group is required.": "Erişim grubu gereklidir.",
        "Device is required.": "Cihaz gerekli.",
        "Admin is required.": "Yönetici gereklidir.",
        "Mobile number": "Mobil numarası",
        "schedules": "programlar",
        "Timetable name": "Zaman çizelgesi adı",
        "Shift name": "Vardiya adı",
        "Leave type": "İzin türü",
        "recheck in time": "Yeniden giriş zamanı",
        "recheck out time": "tekrar çıkış zamanı",
        "The building name": "Bina adı",
        "Building is required.": "Bina gereklidir.",
        "selection, The same reader cannot be set for both entry and exit": "seçim, Giriş ve çıkış için aynı okuyucu ayarlanamaz",
        "Door number": "Kapı numarası",
        "door input cannot be selection duplicated.": "Kapı girişi tekrar seçilemez.",
        "Group is required.": "Grup gerekli.",
        "Title can contain up to 32 characters.": "Başlık en fazla 32 karakter içerebilir.",
        "Content can contain up to 1024 characters.": "İçerik en fazla 1024 karakter içerebilir.",
        "Content can contain up to 64 characters.": "İçerik en fazla 64 karakter içerebilir.",
        "Report is required.": "Rapor gereklidir.",
        "ID is required.": "Kimlik gereklidir.",
        "The office does not exist.": "Ofis mevcut değil.",
        "Office name": "Ofis adı",
        "The Temp Key does not exist.": "Geçici anahtar mevcut değil.",
        "autolock time": "otomatik kilitleme süresi",
        "The User does not exist.": "Kullanıcı mevcut değil.",
        "The Installer does not exist.": "Yükleyici mevcut değil.",
        "The Project does not exist.": "Proje mevcut değil.",
        "The Distributor does not exist.": "Distribütör mevcut değil.",
        "The Community Device does not exist.": "Topluluk cihazı mevcut değil.",
        "The Property Manager does not exist.": "Mülk Yöneticisi mevcut değil.",
        "The Sub Distributor does not exist.": "Alt dağıtıcı mevcut değil.",
        "The Single Slave does not exist.": "Tekil alt hesap mevcut değil.",
        "The Property Manager EndUser does not exist.": "Mülk Yöneticisi Son Kullanıcı mevcut değil.",
        "The Family Member does not exist.": "Aile üyesi mevcut değil.",
        "Set Failed!": "Ayar Başarısız!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "30 dakikalık süre içerisinde 10 erişim kodu isteği limitine ulaştınız. Lütfen daha sonra tekrar deneyin.",
        "This Email doesn\'t exist.": "Bu e-posta mevcut değil.",
        "detection type": "algılama türü",
        "Device UUID": "Cihaz UUID\'si",
        "smart lock device": "akıllı kilit cihazı",
        "You are trying too often, please try again in 5 minutes.": "Çok sık deniyorsunuz, lütfen 5 dakika sonra tekrar deneyin.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Aynı anda yalnızca bir dosya içe aktarabilirsiniz. Lütfen mevcut içe aktarma işleminin bitmesini bekleyin.",
        "NVR Name": "NVR Adı",
        "NVR Address": "NVR Adresi",
        "Stay Alarm": "Kalma Alarmı",
        "Happended On": "Gerçekleşme zamanı",
        "Edit Milesight NVR": "Milesight NVR\'ı Düzenle",
        "Add Milesight NVR": "Milesight NVR Ekle",
        "Auto-record video on motion detection, package detection": "Hareket veya paket algılamada otomatik video kaydı",
        "A 7-day free trial is included with your subscription.": "Aboneliğinizle birlikte 7 günlük ücretsiz deneme dahildir.",
        "For service renewal, please reach out to your provider.": "Servis yenilemesi için lütfen sağlayıcınızla iletişime geçin.",
        "Allow the Property Manager to view recorded videos": "Site Yöneticisinin kayıtlı videoları görüntülemesine izin ver",
        "Please ensure the WiFi network is working properly.": "Lütfen WiFi ağının düzgün çalıştığından emin olun.",
        "Edit akubela Smart Locks": "akubela Akıllı Kilit Düzenle",
        "Upgraded Successfully!": "Başarıyla Yükseltildi!",
        "Upgraded Failed!": "Yükseltme Başarısız!",
        "Editing...": "Düzenleniyor...",
        "Edited successfully!": "Başarıyla Düzenlendi!",
        "Edited Failed!": "Düzenleme Başarısız!",
        "Downloading video...": "Video indiriliyor...",
        "All Locks": "Tüm Kilitler",
        "Select Locks": "Kilit Seç",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "Akubela akıllı kilidi ağa bağlandıktan sonra {0} haneli PIN kullanılabilir. Lütfen unutmayın, PIN kodunun senkronize olduktan sonra etkinleşmesi kısa bir süre alabilir.",
        "Please at least select a door or a lock.": "Lütfen en az bir kapı veya kilit seçin.",
        "This lock has already been added to your apartment.": "Bu kilit zaten dairenize eklendi.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Bu kilit başka bir daireye eklenmiş, lütfen yardım için hizmet sağlayıcınızla iletişime geçin.",
        "LockBody Version": "Kilit Gövdesi Sürümü",
        "Two-factor Authentication": "İki Faktörlü Doğrulama",
        "Monitoring Scope": "İzleme Alanı",
        "Stay Duration": "Kalma Süresi",
        "Volume Settings": "Ses Ayarları",
        "get card list for lock error": "Kilit için kart listesi alınırken hata oluştu.",
        "get card list parse fail": "Kart listesi ayrıştırılamadı.",
        "get pin list for lock error": "Kilit için pin listesi alınırken hata oluştu.",
        "get pin list parse fail": "Pin listesi ayrıştırılamadı.",
        "fingerprint code must be less than 2048 characters or empty.": "Parmak izi kodu 2048 karakterden az veya boş olmalıdır.",
        "Personnel not in office.": "Personel ofiste değil.",
        "customize form fail.": "Form özelleştirilemedi.",
        "smart lock type error.": "Akıllı kilit tipi hatası.",
        "invalid client id or secret": "Geçersiz istemci kimliği veya gizli anahtar",
        "invalid account or password": "Geçersiz hesap veya şifre",
        "invalid access token": "Geçersiz erişim belirteci",
        "invalid refresh token": "Geçersiz yenileme jetonu",
        "no permission to access this project": "Bu projeye erişim izniniz yok",
        "Stay Alarm Time": "Alarm Süresi",
        "This function only support sl20 lock.": "Bu fonksiyon sadece sl20 kilidi destekler.",
        "Json marshal error.": "Json serileştirme hatası.",
        "Json unmarshal error.": "Json serileştirmeyi açma hatası.",
        "Illegal request, not added within valid time.": "Geçersiz istek, geçerli süre içinde eklenmedi.",
        "invalid nvr type": "Geçersiz nvr tipi",
        "project is empty": "Proje boş",
        "project type is invalid": "Proje türü geçersiz",
        "owner is invalid": "Sahibi geçersiz",
        "url is invalid": "URL geçersiz",
        "password is invalid": "Şifre geçersiz",
        "building is invalid": "Bina geçersiz",
        "fail to get data": "Veri alınamadı",
        "invalid allow pm view type": "Geçersiz izin verilen pm görüntüleme türü",
        "Data not exist.": "Veri mevcut değil.",
        "cannot find community PrivateKey.": "Topluluk özel anahtarı bulunamadı.",
        "cannot find single PrivateKey.": "Tekil özel anahtar bulunamadı.",
        "The third party not exist.": "Üçüncü taraf mevcut değil.",
        "{0} and indoor monitors/guard phones": "{0} ve iç mekan monitörleri/görevli telefonları",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} ve iç mekan monitörleri/görevli telefonları, cevap yoksa telefon aranacak",
        "Indoor monitors/guard phones with {0} as backup": "İç mekan monitörleri/görevli telefonları, cevap yoksa {0} aranacak",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "İç mekan monitörleri/görevli telefonları, cevap yoksa önce {0}, son olarak telefon aranacak",
        "{0} Intercom Feature": "{0} İnterkom Özelliği",
        "Capture on {0}": "{0}\'da ekran görüntüsü al",
        "{0} Intercom Feature is not activated or has expired.": "{0} interkom özelliği etkin değil veya süresi dolmuş.",
        "fingerprint code must be equal 1620 characters or empty.": "Parmak izi kodu 1620 karakter olmalı veya boş olmalı.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Yükseltmenin başarılı olması için kilidin pil seviyesinin %40\'ın üzerinde olduğundan emin olun.",
        "Automatic Locking Time": "Otomatik Kilitleme Süresi",
        "WiFi Keep-Alive": "WiFi Bağlantı Koruma",
        "WiFi Setting": "WiFi Ayarı",
        "Connecting the network...": "Ağa bağlanılıyor...",
        "Set successfully!": "Ayar başarıyla yapıldı!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Kilit WiFi\'ye bağlı olmasa bile çevrimdışı kod kullanılabilir.",
        "Enabling this feature will increase the lock\'s power consumption.": "Bu özelliği etkinleştirmek kilidin güç tüketimini artıracaktır.",
        "Each offline code can only be used once.": "Her çevrimdışı kod sadece bir kez kullanılabilir.",
        "Receiver Info": "Alıcı Bilgisi",
        "log id": "Giriş kimliği",
        "Create HW SN Config Empty SN.": "Huawei SN yapılandırmasında boş SN oluştur.",
        "The SN": "Seri Numarası",
        "SN can contain up to 32 characters.": "SN en fazla 32 karakter içerebilir.",
        "Check HW SN Not Found.": "Huawei SN bulunamadı.",
        "the end user not found": "Son kullanıcı bulunamadı",
        "Family Call": "Aile Araması",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Yükseltme sırasında kilitle ilgili tüm işlevler geçici olarak kullanılamaz olacaktır.",
        "8-digit PIN code starting with \"9\" is invalid!": "\"9\" ile başlayan 8 haneli PIN kodu geçersizdir!",
        "Lock name length must be between 1 and 50": "Kilit adı uzunluğu 1 ile 50 arasında olmalıdır.",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Sabit hat hizmeti kullanan personel sayısı, {0} interkom hizmeti kullananların sayısını aşamaz.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Sabit hat hizmetine sahip olan yönetici sayısı, {0} interkom hizmetine sahip olanların sayısını aşamaz.",
        "charge type": "ücret türü",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Sabit hat hizmeti olan personel sayısı, SmartPlus Intercom hizmeti olanların sayısını aşamaz.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Sabit hat hizmeti olan yönetici sayısı, SmartPlus Intercom hizmeti olanların sayısını aşamaz.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Bir okuyucu aynı anda hem Wiegand hem RS485 ile yapılandırılamaz.",
        "parameter error": "parametre hatası",
        "community name already exist": "topluluk ismi zaten mevcut",
        "personnel app without intercom feature number": "interkom özelliği olmayan personel uygulaması numarası",
        "check feature billing charge plan new error": "özellik faturalandırma planı yeni hata",
        "subscription not found": "abonelik bulunamadı",
        "System setting record not found.": "Sistem ayar kaydı bulunamadı.",
        "Smart home not enabled.": "Akıllı ev etkin değil.",
        "the apt call type value is invalid.": "apt arama türü geçersiz.",
        "the ip call or sip call value is invalid.": "IP veya SIP arama değeri geçersiz.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode 2-8 haneli bir sayı olmalı, ancak 9 ile başlayan 8 haneli bir sayı olamaz veya boş olamaz.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard A-F0-9 harflerinden oluşmalı ve 16 bitten az olmalı veya boş olmalı.",
        "owner cannot be empty.": "sahip boş olamaz.",
        "creator cannot be empty.": "oluşturucu boş olamaz.",
        "the creator type value is invalid": "oluşturucu türü değeri geçersiz",
        "the IsCreateByPm value is invalid": "IsCreateByPm değeri geçersiz",
        "the pinCode already exist": "pinCode zaten mevcut",
        "the rfCard already exist": "rfCard zaten mevcut",
        "license plate is invalid.": "plaka geçersiz.",
        "owner info is invalid.": "sahip bilgisi geçersiz.",
        "uhf is invalid.": "uhf geçersiz.",
        "time control is invalid.": "zaman kontrolü geçersiz.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Araç plaka sınırı olan 5\'e ulaştınız, ekleme yapamazsınız",
        "the plate already exist": "plaka zaten mevcut",
        "the uhf already exist": "uhf zaten mevcut",
        "empty community": "boş topluluk",
        "no find license Plate": "plaka bulunamadı",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess modu 0, 1 veya 2 olmalı.",
        "Run field is required when mode is 1 or 2.": "Mod 1 veya 2 olduğunda çalıştırma alanı gereklidir.",
        "Serial field is required when mode is 2.": "Mod 2 olduğunda seri alanı gereklidir.",
        "the pin cannot be empty": "pin boş olamaz",
        "the rfCard cannot be empty": "rfCard boş olamaz",
        "the IDAccess already exist": "IDAccess zaten mevcut",
        "the resident cannot be empty": "sakin boş olamaz",
        "the fingerprint cannot be empty": "parmak izi boş olamaz",
        "the face cannot be empty": "yüz boş olamaz",
        "not found pin": "pin bulunamadı",
        "not found rfCard": "rfCard bulunamadı",
        "not found IDAccess": "IDAccess bulunamadı",
        "not found fingerprint": "parmak izi bulunamadı",
        "not found face": "yüz bulunamadı",
        "face pic is invalid.": "yüz fotoğrafı geçersiz.",
        "community build and room cannot be empty.": "topluluk ve oda bilgileri boş olamaz.",
        "device info mac cannot be empty.": "cihaz bilgisi mac boş olamaz.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "zamanlayıcı tipi 0, 1, 2 olmalı veya zaman formatı geçersiz ya da veri bayrağı 0-127 arasında olmalı.",
        "MAC address cannot be empty.": "MAC adresi boş olamaz.",
        "MAC address 0C1105000000 is not allowed.": "MAC adresi 0C1105000000\'a izin verilmez.",
        "MAC address must be 12 hexadecimal characters.": "MAC adresi 12 onaltılık karakter olmalı.",
        "Scheduler type value is invalid.": "Zamanlayıcı tipi değeri geçersiz.",
        "parse is fail": "ayrıştırma başarısız",
        "the fingerprint already exist": "parmak izi zaten mevcut",
        "the licensePlate cannot be empty": "plaka boş olamaz",
        "the licensePlate already exist": "plaka zaten mevcut",
        "idaccess run must be 10 digit number or end with -K.": "idaccess çalıştırma 10 haneli sayı olmalı veya -K ile bitmeli.",
        "idaccess serial must be 9 digit number.": "idaccess seri numarası 9 haneli olmalı.",
        "relay not in 0-15": "röle 0-15 aralığında değil",
        "security relay not in 0-3": "güvenlik rölesi 0-3 aralığında değil",
        "file name is wrong": "dosya adı yanlış",
        "access mode specified": "erişim modu belirtildi",
        "create community user accessmode failed.": "topluluk kullanıcı erişim modu oluşturulamadı.",
        "delete community user accessmode failed.": "topluluk kullanıcı erişim modu silinemedi.",
        "Cannot delete building because it has associated users.": "Binayı silemezsiniz çünkü ilişkili kullanıcılar var.",
        "Cannot delete building because it has associated Salto devices.": "Bina silinemiyor çünkü ona bağlı Salto cihazları var.",
        "community building not found": "topluluk binası bulunamadı",
        "Invalid Name Display": "Geçersiz isim gösterimi",
        "The Community does not exist.": "Topluluk mevcut değil.",
        "Update CommunityIsInstallerKit Error.": "CommunityIsInstallerKit güncelleme hatası.",
        "Dis Not SupportCommunityCalls Error.": "Bayi topluluk çağrılarını desteklemiyor hatası.",
        "Community Has Special Device, Not Allowed To Delete.": "Toplulukta özel cihaz var, silinmesine izin verilmez.",
        "The project smart home switch must be disabled": "Proje akıllı ev anahtarı devre dışı bırakılmalı",
        "There are ITec Locks in project": "Projede ITec kilitler var",
        "There are Salto Locks in project": "Projede Salto kilitler var",
        "There are Dormakaba Locks in project": "Projede Dormakaba kilitler var",
        "It is rent manager project": "Bu bir rent manager projesi",
        "It is installer account": "Bu bir kurulumcu hesabı",
        "contact preference type": "arama tercihi tipi",
        "Floor list is required when not all floors.": "Tüm katlar değilse, kat listesi gereklidir.",
        "Building floors list is required when all buildings.": "Tüm binalar için bina katları listesi gereklidir.",
        "Indoor monitor name is required.": "İç ünite adı gereklidir.",
        "The primary account is not activated.": "Ana hesap aktif edilmemiş.",
        "You can\'t create more family member accounts.": "Daha fazla aile üyesi hesabı oluşturamazsınız.",
        "community user not found": "topluluk kullanıcısı bulunamadı",
        "community is empty": "topluluk boş",
        "the end user not master user": "son kullanıcı ana kullanıcı değil",
        "the end user not member user": "son kullanıcı üye kullanıcı değil",
        "The email already exists and cannot be repeated": "Bu e-posta zaten mevcut, tekrar edilemez",
        "The mobile Number already exists": "Cep telefonu numarası zaten var",
        "The room number format error.": "Oda numarası format hatası.",
        "community not found": "topluluk bulunamadı",
        "resident not found": "sakin bulunamadı",
        "installer not found": "kurulumcu bulunamadı",
        "Operation Failed!": "İşlem başarısız!",
        "You don\'t have operate permission": "İşlem izniniz yok",
        "You cannot select Relay and Door at the same time": "Aynı anda röle ve kapı seçemezsiniz",
        "user don\'t active": "kullanıcı aktif değil",
        "User has expired": "kullanıcı süresi doldu",
        "timestamp must be within 3 minutes of current server time": "zaman damgası, mevcut sunucu zamanının 3 dakikası içinde olmalı",
        "cannot find single rf Card.": "Tek rf Card bulunamadı.",
        "cannot find community rf Card.": "Topluluk rf Card bulunamadı.",
        "smartLock model": "akıllı kilit modeli",
        "the project does not open smart home": "proje akıllı evi açmıyor",
        "php web server error": "php web sunucu hatası",
        "Ins not found.": "Ins bulunamadı.",
        "RentManage Unit Not Set.": "RentManage birimi ayarlanmadı.",
        "add audit log error": "denetim günlüğü ekleme hatası",
        "check building in error": "bina kontrolünde hata",
        "Special devices cannot be deleted": "Özel cihazlar silinemez",
        "the email is empty": "e-posta boş",
        "the email format is incorrect": "e-posta formatı yanlış",
        "the mobile number is empty": "cep telefonu numarası boş",
        "the mobile number format is incorrect": "cep telefonu numarası formatı yanlış",
        "Site not found": "Site bulunamadı",
        "User not found": "Kullanıcı bulunamadı",
        "invalid time format": "geçersiz zaman formatı",
        "ground floor type": "zemin kat türü",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Başlangıç katı aralığı hatası, geçerli değerler -10 ila -1, G0, G1, G2, 1 ila 128\'dir.",
        "Building ID must be between 1 and 99.": "Bina kimliği 1 ile 99 arasında olmalı.",
        "Community building name": "Topluluk bina adı",
        "Building ID already exists in this community.": "Bu toplulukta bina kimliği zaten mevcut.",
        "building ID": "bina kimliği",
        "Community building not found.": "Topluluk binası bulunamadı.",
        "Cannot delete building because it has associated devices.": "Binayı silemezsiniz çünkü ilişkili cihazlar var.",
        "project is not valid": "proje geçersiz",
        "Cannot delete building because it has associated salto devices.": "Binayı silemezsiniz çünkü ilişkili salto cihazları var.",
        "Cannot delete building because it has associated iTec devices.": "Binayı silemezsiniz çünkü ilişkili iTec cihazları var.",
        "Cannot delete building because it has associated dormakaba devices.": "Binayı silemezsiniz çünkü ilişkili dormakaba cihazları var.",
        "member limit num": "üye sınır sayısı",
        "Indoor Monitor No Set Error.": "İç ünite ayarlanmamış hatası.",
        "The room not has indoor": "Odada iç ünite yok.",
        "check user in building error": "binadaki kullanıcı hatasını kontrol et",
        "The name specified is already in use.": "Belirtilen isim zaten kullanımda.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Bu zaman dilimi mevcut bir zaman dilimiyle çakışıyor. Lütfen düzenleyin.",
        "This door status changed. Please try again.": "Kapı durumu değişti. Lütfen tekrar deneyin.",
        "the lock can\'t bind this community": "Bu kilit bu topluluğu bağlayamaz.",
        "The custom quantity limit has been exceeded!": "Özel miktar sınırı aşıldı!",
        "This time span overlaps with an existing one. Please adjust it.": "Bu zaman aralığı mevcut bir zaman aralığıyla çakışıyor. Lütfen düzenleyin.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Bu tek seferlik zamanlama, mevcut bir tek seferlik zamanlamanın geçerli süresiyle çakışıyor. Lütfen ayarlayın.",
        "Operation Failed. Please try again.": "İşlem başarısız oldu. Lütfen tekrar deneyin.",
        "The image is not a front view.": "Görüntü ön cephe değildir.",
        "A mask was detected.": "Bir maske tespit edildi.",
        "The image resolution is too low.": "Görüntü çözünürlüğü çok düşük.",
        "No face was detected.": "Yüz tespit edilmedi.",
        "The file size is too large.": "Dosya boyutu çok büyük.",
        "The face in the image is too large.": "Görüntüdeki yüz çok büyük.",
        "The face in the image is too small.": "Görüntüdeki yüz çok küçük.",
        "Multiple faces detected.": "Birden fazla yüz tespit edildi.",
        "The face is not clear enough.": "Yüz yeterince net değil.",
        "Face detection failed.": "Yüz algılama başarısız oldu.",
        "Please enter a value between 1 and 9999": "Lütfen 1 ile 9999 arasında bir değer giriniz.",
        "Please select which input your door sensor is connected to.": "Lütfen kapı sensörünüzün bağlı olduğu girişi seçin.",
        "Add temp key failed, please try it again": "Geçici anahtar eklenemedi, lütfen tekrar deneyin",
        "Dis Not Support Dynamic QRCode Error.": "Distribütör dinamik QR kodunu desteklemiyor hatası.",
        "QR code not exist": "QR kodu mevcut değil",
        "The temp key has expired.": "Geçici anahtarın süresi doldu.",
        "The device is not in the office": "Cihaz ofiste değil",
        "The device is already assigned.": "Cihaz zaten atanmış.",
        "The device cannot be assigned to any user.": "Cihaz hiçbir kullanıcıya atanamaz.",
        "You cannot select an option with fewer users than the current project members.": "Mevcut proje üyelerinden daha az kullanıcıya sahip bir seçeneği seçemezsiniz.",
        "File check failed. Please download the latest template and try again.": "Dosya kontrolü başarısız oldu. Lütfen en son şablonu indirip tekrar deneyin.",
        "Dynamic QR Code not active.": "Dinamik QR Kodu aktif değil.",
        "Dynamic QR Code not enable.": "Dinamik QR Kodu etkin değil.",
        "{0} not found.": "{0} bulunamadı.",
        "Tier charge plan": "Kademeli ücret planı",
        "Feature billing charge plan new": "Özellik faturalandırma ücreti planı yeni",
        "Feature billing gradient charge plan": "Özellik faturalandırma gradyan ücret planı",
        "The exit time cannot be earlier than the entry time.": "Çıkış zamanı giriş zamanından önce olamaz.",
        "User Name or Password": "Kullanıcı adı veya parola",
        "You can only link up to 5 sites.": "En fazla 5 site ilişkilendirebilirsiniz.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Bu plaka zaten bir sakin adına kayıtlıdır ve kara listeye eklenemez.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Bu plaka kara listeye alınmıştır ve araç olarak kaydedilemez.",
        "Elevator not configured in company access floor.": "Asansör şirketin erişim katında yapılandırılmamış.",
        "the device is not in the office": "cihaz ofiste değil",
        "A maximum of 1000 data items can be imported": "En fazla 1000 veri öğesi içe aktarılabilir",
        "Exit time cannot be later than the current time.": "Çıkış zamanı mevcut zamandan daha geç olamaz.",
        "You can only import a file at a time in the current parking lot.": "Mevcut otoparkta her seferinde yalnızca bir dosya içe aktarabilirsiniz.",
        "The license plate is already in the blocklist.": "Plaka zaten kara listede.",
        "Building name too long.": "Bina adı çok uzun.",
        "Unlock failed. Permission denied by user.": "Kilidi açma başarısız. İzin kullanıcı tarafından reddedildi.",
        "Please remove the sensor device(s) before disabling this feature.": "Bu özelliği devre dışı bırakmadan önce lütfen sensör cihaz(lar)ını kaldırın.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "İşlem başarısız! Bu kullanıcı için günlük 15 kayıt limiti aşıldı.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Her projeye en fazla {0} genel cihaz eklenebilir. Daha fazla eklemek için lütfen support{'@'}akuvox.com adresinden Akuvox Teknik Destek ile iletişime geçin.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Her projeye en fazla {0} personel hesabı eklenebilir. Daha fazla eklemek için lütfen support{'@'}akuvox.com adresinden Akuvox Teknik Destek ile iletişime geçin.",
        "cancel": "İptal",
        "bluetooth": "Bluetooth",
        "Battery Level": "Pil Seviyesi",
        "tamperAlarm": "Dış Müdahale Alarmı",


    }
};
